import clsx from "clsx";

export interface Props {
  children: React.ReactNode;
  className?: string | string[];
}

const Tag = ({ className, children }: Props) => {
  return (
    <div
      className={clsx(
        "flex",
        "justify-center",
        "items-center",
        "m-1",
        "font-medium",
        "py-1",
        "px-2",
        "rounded-full",
        // textColorClass || "text-gray-700",
        // bgColorClass || "bg-gray-200",
        className
      )}
    >
      <div className="text-xs font-semibold leading-none max-w-full flex-initial">
        {children}
      </div>
    </div>
  );
};

export default Tag;
